import styled from "styled-components";

export const IndicatorDiv = styled.div`
  width: 100%;
  max-width: 860px;
  margin: 0 auto 15px;
`;
export const InfoText = styled.p`
  font-size: 14px;
  color: #000;
`;
